export default "__VITE_ASSET__D_3LJkpd__"